module.exports = __webpack_public_path__ + "img/specimen-light.6c29719a.png";